export const EARLIEST_SYNC_START_DATE = '2024-01-01'
